
    import {useStore} from "@/store";
    // , computed, ComputedRef, watch, reactive
    import  reportMsgUt from "@/util/reportMsg";
    import {defineComponent, watch, reactive, toRefs} from "vue";
    import {useRouter,useRoute} from "vue-router";

interface State {
    reportMsg: object;
    templateCode: string;
}
export default defineComponent({
    name: 'checkTitle',
    props: {
        itemCode: {
            type: String,
            default: ''
        },
        titleCont: {
            type: String,
            default: ''
        },
        count: {
            type: String,
            default: ''
        },
        checkStandardRouter: {
            type: String,
            default: ''
        }
    },
    setup() {
        let state: State = reactive({
            reportMsg: {},
            templateCode: ''

        })
        state.reportMsg = reportMsgUt;

        let store = useStore()
        // 获取路由器实例
        const router = useRouter()
        const {query} = useRoute();
        const { templateCode} = query;
        state.templateCode = String(templateCode);
        return {
            store,
            state,
            router
        }
    },
    methods: {
        handleClick(checkTitle){
            this.store.dispatch('savePageScrollTop', window.scrollY);
            if (this.checkStandardRouter) {
                let router = 'promiseFrame' + this.checkStandardRouter.charAt(0).toUpperCase() + this.checkStandardRouter.slice(1);
                this.router.push({
                    path: `/${router}`,
                    query: {
                        checkTitle,
                        templateCode: this.state.templateCode
                    }
                })
            } else {
                this.router.push({
                    path: '/promiseFrameCheckStandard',
                    query: {
                        checkTitle,
                        templateCode: this.state.templateCode
                    }
                })
            }
        }
    }
})
